import { TanStackRouterDevtools as TanStackRouterDevtools$1 } from "./TanStackRouterDevtools.js";
import { TanStackRouterDevtoolsPanel as TanStackRouterDevtoolsPanel$1 } from "./TanStackRouterDevtoolsPanel.js";
const TanStackRouterDevtools = process.env.NODE_ENV !== "development" ? function() {
  return null;
} : TanStackRouterDevtools$1;
const TanStackRouterDevtoolsInProd = TanStackRouterDevtools$1;
const TanStackRouterDevtoolsPanel = process.env.NODE_ENV !== "development" ? function() {
  return null;
} : TanStackRouterDevtoolsPanel$1;
const TanStackRouterDevtoolsPanelInProd = TanStackRouterDevtoolsPanel$1;
export {
  TanStackRouterDevtools,
  TanStackRouterDevtoolsInProd,
  TanStackRouterDevtoolsPanel,
  TanStackRouterDevtoolsPanelInProd
};
//# sourceMappingURL=index.js.map
